import React from 'react';
import { Box, CircularProgress, Alert, Skeleton } from '@mui/material';
import { MoSpacing } from '@motivo/guanyin/src/components';

export function LoadingSpinner() {
  return (
    <Box display="flex" justifyContent="center" py={4}>
      <CircularProgress />
    </Box>
  );
}

export function LoadingSkeleton({ count = 3 }: { count?: number }) {
  return (
    <MoSpacing y={2}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton key={index} variant="rectangular" height={80} />
      ))}
    </MoSpacing>
  );
}

interface ErrorDisplayProps {
  error: Error | string;
  onRetry?: () => void;
}

export function ErrorDisplay({ error, onRetry }: ErrorDisplayProps) {
  const errorMessage = typeof error === 'string' ? error : error.message;

  return (
    <Alert severity="error" action={onRetry && <button onClick={onRetry}>Retry</button>}>
      {errorMessage}
    </Alert>
  );
}

interface EmptyStateProps {
  message: string;
}

export function EmptyState({ message }: EmptyStateProps) {
  return (
    <Alert severity="info" sx={{ my: 2 }}>
      {message}
    </Alert>
  );
}
